import { inject, injectable } from "inversify";
import { ApiPage } from "@/core/models/page.model";
import { TableRepo } from "../table.repo";
import { TollAreaRepo } from "./toll-area.repo";
import { ReadMeterPeriodModel } from "@/core/models/read-meter-period.model";
import { TollAreaModel } from "@/core/models/toll-area/toll-area.model";

interface _ReadMeterPeriodGetParams {
    search?: string;
    year?: number;
    month?: number;
}

interface _PagePayload {
    tollArea: TollAreaModel,
    readMeterPeriod: ReadMeterPeriodModel,
    waterIndexTotal: number,
    waterUserTotal: number
}

@injectable()
export class ReadMeterPeriodRepo extends TableRepo<ReadMeterPeriodModel> {
    @inject(TollAreaRepo)
    private tollAreaRepo!: TollAreaRepo;

    constructor() {
        super("/api/ReadMeterPeriod");
    }

    async getData(index: number, params: _ReadMeterPeriodGetParams, pageSize = 10): Promise<ApiPage<ReadMeterPeriodModel>|null> {
        const fetchData = async (): Promise<ApiPage<ReadMeterPeriodModel>|null> => {
            const response = await this.apiRepo.get<ApiPage<_PagePayload>>(`${this.basepath}/${"page-by-manager"}`, {
                pageSize: pageSize,
                pageIndex: index,
                ...params
            })
            if (response?.result) {
                const result = response.result;
                return {...result, data: result.data.map(e => ({
                    ...e.readMeterPeriod,
                    waterIndexTotal: e.waterIndexTotal,
                    waterUserTotal: e.waterUserTotal
                }))}
            }
            return null;
        }
        const result = await fetchData();
        // if (result) {
        //     const data: ReadMeterPeriodModel[] = [];
        //     for (const record of result.data) {
        //         const populatedRecord: ReadMeterPeriodModel = {
        //             ...record,
        //         };
        //         data.push(populatedRecord);
        //     }
        //     result.data = data;
        //     return result;
        // }
        console.log(result);
        return result;
    }
    async create(model: ReadMeterPeriodModel) {
        return super.create(model, "add-by-location")
    }
    async update(model: ReadMeterPeriodModel) {
        return super.update({...model, tollAreaId: model.tollArea.id});
    }

    async toggleLock(model: ReadMeterPeriodUpdateLockPayload) {
        try {
            const response = await this.apiRepo.post(`${this.basepath}/update-lock`, model);
            if (response?.code === '00') {
                this.changes.next(Date.now());
                return true
            };
            return false;
        } catch (err) {
            console.log(err);
        }
    }
}

export interface ReadMeterPeriodUpdateLockPayload {
    year: number,
    month: number,
    isAllowReading: boolean
}